import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.apiKeyError ? _c(VContainer, {
    staticClass: "fill-height pa-0",
    attrs: {
      "fluid": ""
    }
  }, [!_vm.apiKeyError ? _c('core-dtwin-map-public', {
    ref: "mapInstance",
    attrs: {
      "markerItems": _vm.markerItems,
      "clusters": _vm.dtwinClusters,
      "polygons": _vm.polygons,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "cameraObj": _vm.camera,
      "gradientPolygonColours": _vm.gradientPolygonColours,
      "selectedCluster": _vm.selectedCluster,
      "mapBoundsLock": _vm.mapBoundsLock
    },
    on: {
      "map-moved": e => _vm.loadTree(e.bounds, e.stateKey, e.twinTag),
      "getClusterContent": _vm.getClusterContent
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function () {
        return [!_vm.apiKeyError && _vm.footerData.showFooterPublicDashboard ? _c('div', {
          class: _vm.showBottomBar ? 'mapLayerFooter' : 'mapLayerFooterBottom',
          staticStyle: {
            "z-index": "5",
            "background-color": "#ffffffa0",
            "width": "152px",
            "padding-top": "3px"
          }
        }, [_c('core-footer', {
          attrs: {
            "footerData": _vm.footerData,
            "publicDashboardVersion": true
          }
        })], 1) : _vm._e(), _vm.showBottomBar ? _c('div', {
          staticClass: "mapLayerControl",
          staticStyle: {
            "z-index": "5"
          }
        }, [_c(VRow, {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex",
            "flex-direction": "row",
            "justify-content": "flex-start",
            "align-items": "center"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm.buildingFloorList && _vm.buildingFloorList.length > 1 ? _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VMenu, {
          attrs: {
            "open-on-hover": "",
            "close-delay": "200",
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VBtn, _vm._g({
                class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
                attrs: {
                  "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
                  "color": _vm.color,
                  "icon": "",
                  "info": "",
                  "fab": "",
                  "text": ""
                }
              }, on), [_c(VIcon, [_vm._v("fal fa-layer-plus")])], 1)];
            }
          }], null, false, 3162116487)
        }, [_c(VList, _vm._l(_vm.buildingFloorList, function (floor, index) {
          return _c(VListItem, {
            key: index
          }, [_c(VBtn, {
            attrs: {
              "outlined": _vm.indoorFloorDtwinId === floor.id,
              "elevation": _vm.indoorFloorDtwinId === floor.id ? 2 : 1,
              "plain": ""
            },
            on: {
              "click": function ($event) {
                _vm.indoorFloorDtwinId = floor.id;
              }
            }
          }, [_vm._v("\n                    " + _vm._s(floor.floorNumber || floor.title) + "\n                  ")])], 1);
        }), 1)], 1)], 1) : _vm._e(), _vm.floorList.length ? _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VMenu, {
          attrs: {
            "close-on-content-click": false,
            "min-width": "300",
            "max-width": "300",
            "nudge-left": "12",
            "offset-x": "",
            "bottom": "",
            "right": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VBtn, _vm._g({
                class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
                attrs: {
                  "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settings'),
                  "color": _vm.color,
                  "icon": "",
                  "info": "",
                  "fab": "",
                  "text": ""
                }
              }, on), [_c(VIcon, [_vm._v("fal fa-layer-group")])], 1)];
            }
          }], null, false, 2915292552)
        }, [_c(VCard, [_c(VContainer, {
          staticClass: "pa-6",
          attrs: {
            "fluid": ""
          }
        }, [_c(VRow, {
          staticStyle: {
            "min-width": "0"
          }
        }, [_c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorSwitcher')) + "\n                      ")]), _c(VSwitch, {
          attrs: {
            "true-value": true,
            "color": _vm.color,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.indoorEnable'),
            "hide-details": ""
          },
          model: {
            value: _vm.indoorEnabled,
            callback: function ($$v) {
              _vm.indoorEnabled = $$v;
            },
            expression: "indoorEnabled"
          }
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.types.building')) + "\n                      ")]), _c(VSelect, {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "items": _vm.buildingList,
            "disabled": !_vm.indoorEnabled,
            "item-text": "title",
            "item-value": "id",
            "hide-details": "",
            "dense": "",
            "solo": ""
          },
          model: {
            value: _vm.indoorBuildingId,
            callback: function ($$v) {
              _vm.indoorBuildingId = $$v;
            },
            expression: "indoorBuildingId"
          }
        })], 1), _c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c(VDivider, {
          staticClass: "mb-4"
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor')) + "\n                      ")]), _c(VSelect, {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "items": (_vm.groupedFloors[`${_vm.indoorBuildingId}`] || {}).floors || [],
            "disabled": !_vm.indoorEnabled,
            "item-text": "title",
            "item-value": "id",
            "hide-details": "",
            "dense": "",
            "solo": ""
          },
          model: {
            value: _vm.indoorFloorDtwinId,
            callback: function ($$v) {
              _vm.indoorFloorDtwinId = $$v;
            },
            expression: "indoorFloorDtwinId"
          }
        }), _c(VDivider, {
          staticClass: "mt-4"
        })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 2519823961)
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "height": "100vh",
      "color": "red"
    }
  }, [_c('h2', [_vm._v("Error: Unauthorized")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };